import { CardComponentProps } from "@~/types/types";
import styles from "./Title.module.scss";
import { getTitleWithoutBrand, isAnydayBrand } from "@~/utils/brands";
import classNames from "classnames/bind";
import { ProductLink } from "../__shared__/ProductLink/ProductLink";
import { SponsorMessage } from "../SponsorMessage/SponsorMessage";
import { Brand } from "./components/Brand/Brand";

const cx = classNames.bind(styles);

export const Title = ({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) => {
  const { title } = product;
  if (!title) return null;

  const HeadingElement =
    `h${configProps?.titleTag || 2}` as keyof React.JSX.IntrinsicElements;

  return (
    <ProductLink
      product={product}
      componentName="Title"
      opensQuickView={configProps?.productLinkOpensQuickView === true}
      quickViewConfig={configProps?.qvConfig as string | undefined}
    >
      <HeadingElement className={styles.title} data-testid="product-title">
        <TitleContent product={product} configProps={configProps} />
      </HeadingElement>
      {configProps?.showSponsorMessage !== false && (
        <SponsorMessage product={product} />
      )}
    </ProductLink>
  );
};

function TitleContent({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { title } = product;
  const brand = product.brand?.name;

  const isAnyDayBrandedProduct = isAnydayBrand(brand);
  const isUnbrandedProduct = brand === "Unbranded";

  const showBrandedTitle =
    !isUnbrandedProduct &&
    (isAnyDayBrandedProduct ||
      brand === "CHANEL" ||
      configProps?.showBrandedTitle);

  if (brand && configProps?.brandOnly) {
    return <Brand brand={brand} />;
  }

  if (showBrandedTitle) {
    return (
      <>
        <Brand
          brand={brand}
          showLargeBrand={configProps?.largeBrand as boolean}
        />
        <span
          className={cx(
            "title__desc",
            { title__desc__three_lines: configProps?.threeLines !== false },
            "title__desc__branded",
          )}
        >
          {getTitleWithoutBrand(title, brand)}
        </span>
      </>
    );
  }

  return (
    <span
      className={cx("title__desc", "title__desc__four_lines", {
        title__desc__branded: showBrandedTitle,
      })}
    >
      {title}
    </span>
  );
}
